/**
 * @ngdoc Directive
 * @name vrm-icon-button
 * @example
 *
 * <vrm-icon-button ng-model="help" ng-value="true" />
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmIconButton', vrmIconButton);


    /* @ngInject */
    function vrmIconButton() {

        var definition = {
            scope: true,
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/icon-button/icon-button.template.html'),
            link: link
        };

        return definition;

        /**
         * Link
         * @param $scope
         * @param $element
         * @param $attr
         */
        function link($scope, $element, $attr, ngModelController) {
            $scope.active = false;
            $scope.iconClass = $attr.iconClass;
            $scope.aClass = $attr.aClass;
            // i18n path
            $scope.buttonTextPath = $attr.buttonTextPath;
        }
    }
})();
